import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchBlockFadvRequestorMetadata } from "model/BlockFadvRequestorModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const BlockFadvRequestorContext = createContext();

export const BlockFadvRequestorProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [blockFadvRequestorContextData, setBlockFadvRequestorContextData] = useState();

    const fetchBlockFadvRequestorContextData = async () => {
        setLoading(true);
        try {
            const response = await fetchMetadataSchema("metadata:blockFadvRequestor", () =>
                fetchBlockFadvRequestorMetadata({})
            );
            if (response?.success) {
                setBlockFadvRequestorContextData(response?.data);
            }
        } catch (err) {
            toast.error(err?.message || "Unable to fetch block FADV requestor metadata");
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <BlockFadvRequestorContext.Provider
            value={{
                fetchBlockFadvRequestorContextData,
                blockFadvRequestorContextData,
                loading,
                error,
            }}
        >
            {children}
        </BlockFadvRequestorContext.Provider>
    );
};

export const useBlockFadvRequestorContext = () => useContext(BlockFadvRequestorContext);
